
import { ApolloClient, ApolloError } from 'apollo-client'
import { createHttpLink } from 'apollo-link-http'
import { InMemoryCache } from 'apollo-cache-inmemory'

const baseURL = process.env.NODE_ENV === 'production' ? process.env.VUE_APP_URL : process.env.VUE_APP_URL_LOCAL

// HTTP connection to the API
const httpLink = createHttpLink({
  // You should use an absolute URL here
  uri: baseURL
})

// Cache implementation
const cache = new InMemoryCache()

// Create the apollo client
const apolloClient = new ApolloClient({
  link: httpLink,
  cache
})

// eslint-disable-next-line
export const getFirstErrorApollo = (e: any) => {
  const errors = new ApolloError(e)
  const msg = errors.graphQLErrors.map(e => e.message)
  return msg[0]
}

export default apolloClient
